module.exports = __webpack_public_path__ + "img/12.9f177e26.jpg";